
/**
 * Filters based on categories
 */
export const faqSearchFilter = (): void => {
  const faqListWrapper = document.querySelector('.js-faqList') as unknown as HTMLElement

  if (!faqListWrapper) { return }

  // Pre-select all FAQ elements
  const faqList = Array.from(faqListWrapper.querySelectorAll('.js-faqList-single')) as unknown as HTMLElement[]

  // Pre-select all category triggers
  const catList = Array.from(faqListWrapper.querySelectorAll('.js-faqList-category')) as unknown as HTMLElement[]

  catList.forEach(cat => {
    cat.addEventListener('click', (e: Event) => {
      catList.forEach(catSub => {
        catSub.classList.remove('-active')
      })

      cat.classList.add('-active')

      const catSlug = cat.dataset.catSlug as string

      faqList.forEach(faq => {
        const catList = faq.dataset.catList

        console.log(catList)

        if (catList?.includes(catSlug)) {
          faq.style.display = 'block'
        } else {
          faq.style.display = 'none'
        }
      })
    })
  })
}

/**
 * Handles the opening and closing of the FAQ list items
 */
export const faqListControls = (): void => {
  const faqListWrapper = document.querySelector('.js-faqList') as unknown as HTMLElement

  if (!faqListWrapper) { return }

  const itemList = Array.from(faqListWrapper.querySelectorAll('.js-faqList-single-control')) as unknown as HTMLElement[]

  itemList.forEach(single => {
    single.addEventListener('click', () => {
      const wrapper = single.closest('.js-faqList-single') as unknown as HTMLElement

      // If the element is animating, kill the script and wait
      if (wrapper.classList.contains('-animating')) {
        return
      }

      // Add animation lock
      wrapper.classList.add('-animating')

      // Do a basing selection and set current max height for smooth animation
      const contentWrapper = wrapper.querySelector('.js-single-contentWrapper') as unknown as HTMLElement
      const content = wrapper.querySelector('.js-single-content') as unknown as HTMLElement
      const contentHeight = content.clientHeight
      contentWrapper.style.maxHeight = `${contentHeight}px`

      // Opening & Closing
      if (wrapper.classList.contains('-closed')) {
        // Open
        wrapper.classList.remove('-elipsis')

        // Wait before animation to avoid glitching and let DOM update first
        setTimeout(() => {
          const contentHeight = content.clientHeight
          contentWrapper.style.maxHeight = `${contentHeight}px`
          // Wait for animation
          setTimeout(() => {
            wrapper.classList.remove('-closed')
            contentWrapper.style.removeProperty('max-height')
            wrapper.classList.remove('-animating')
          }, 300)
        }, 50)
      } else {
        // Close
        const contentWrapper = wrapper.querySelector('.js-single-contentWrapper') as unknown as HTMLElement

        // Wait before animation to avoid glitching and let DOM update first
        setTimeout(() => {
          contentWrapper.style.maxHeight = (window.innerWidth > 991) ? '0px' : '0px'

          // Wait for animation
          setTimeout(() => {
            wrapper.classList.add('-closed')
            wrapper.classList.add('-elipsis')
            wrapper.classList.remove('-animating')
          }, 250)
        }, 50)
      }
    })
  })
}
